import { UI, Stack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { CoesApplicationProps } from '../..';
import { InputMoney } from '../../../../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../../../../components/RiskRating';
import { useRecoilQuery } from '../../../../../../../../../../hooks/useRecoilQuery';
import { CoeOfferDetailsQuery as coeOfferDetailsQuery } from '../../../../../../../../../../store/batchTicket/selectors';
import { CoesController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/Coes';
import { ProductCard } from '../../../../components/ProductCard';

import { normalizeBillingTypeOptions } from './constants';

export interface CoesInvestCardProps {
  offer: CoesApplicationProps['offer'];
  offerController: CoesController;
  billingTypeSelected: string | undefined;
  setBillingTypeSelected: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const CoesInvestCard: React.FC<CoesInvestCardProps> = ({
  offer,
  offerController,
  billingTypeSelected,
  setBillingTypeSelected,
}) => {
  const id = offer.productIdNormalized;
  const {
    control,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    isFocused,
    currentValueFormatted,
  } = offerController;

  const { data: coeDetails, loading: coeDetailsIsLoading } = useRecoilQuery(
    coeOfferDetailsQuery({ productId: id })
  );

  const billingTypeOptions = normalizeBillingTypeOptions(coeDetails?.data);

  return (
    <ProductCard
      infos={[
        {
          label: 'Risco',
          value: (
            <RiskRating
              currentRiskRating={offer.riskRatingScoreNormalized}
              tooltip={offer.riskRatingNormalized}
            />
          ),
        },
        { label: 'Vencimento', value: offer.maturityDateNormalized },
        { label: 'Aplicação em', value: offer.applicationIn || coeDetails?.data?.applicationIn },
        { label: 'Aplicação mínima', value: Utils.Mask.Money(offer.minimumApplicationNormalized) },
      ]}
      productColor="product.estruturados"
      title={offer.productNameNormalized}
      subtitle={offer.strategyNormalized}
      BottomComponent={
        <VStack space="stack.xxxs">
          <VStack space={'stack.quarck'} justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Tipo de boletagem
            </UI.Text>
            <Stack bgColor="background" borderRadius={BoxBorder.thick} w="full">
              <UI.Select
                triggerProps={{
                  isDisabled: coeDetailsIsLoading || billingTypeOptions.length === 0,
                  _disabled: { opacity: 0.2 },
                }}
                testID="select-ticket-type"
                options={billingTypeOptions}
                placeholder={'Selecione uma opção'}
                selectedValue={billingTypeSelected}
                onValueChange={setBillingTypeSelected}
              />
            </Stack>
          </VStack>
          <VStack space={'stack.quarck'} w="full">
            <UI.Text color="neutral.black" variant="semibold">
              Valor a aplicar
            </UI.Text>
            <InputMoney
              id={`coes-input${id}`}
              name="createAppliedAmount"
              control={control}
              handleFocus={handleInputFocus}
              handleBlur={handleInputBlur}
              handleSubmit={handleSubmit}
              handleClear={handleInputClear}
              currentValue={currentValueFormatted}
              hasFocus={isFocused}
              minValue={offer.minimumApplication}
              customInputProps={{
                ...{ ...(isFocused && hasError && { error: hasError }) },
                ...{ ...(isFocused && !hasError && { helpText }) },
              }}
            />
          </VStack>
        </VStack>
      }
    />
  );
};
